exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "._2aLdn ._2gLB6{margin-bottom:36px}._2aLdn .mlFSc{padding-left:6px}._2aLdn .fCE3M{max-width:600px}\n", ""]);

// Exports
exports.locals = {
	"root": "_2aLdn",
	"section": "_2gLB6",
	"learn-more-button": "mlFSc",
	"learnMoreButton": "mlFSc",
	"disclaimer-text": "fCE3M",
	"disclaimerText": "fCE3M"
};